import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selectorFamily } from 'recoil';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { refreshDeductibleOptionsAtom } from '../atoms/refreshDeductibleOptionsAtom';

export const deductibleOptionsSelector = selectorFamily({
    key: 'deductibleOptionsSelector',
    get:
        (coverageId: string) =>
        async ({ get }) => {
            get(refreshDeductibleOptionsAtom);

            const { jobNumber, sessionId } = get(jobInfoAtom);
            const { fixedId, lobCode } = get(getOnsaCurrentProductSelector);
            const isLoggedOn = get(isLoggedOnSelector);

            if (!jobNumber) throw new Error('Invalid jobId');
            if (!sessionId) throw new Error('Invalid sessionId');
            if (!lobCode) throw new Error('Invalid linePrefix');
            if (!fixedId) throw new Error('Invalid coverableFixedId');
            if (!coverageId) throw new Error('Invalid coverageId');

            return await OnlineSalesUnauthenticated.getDeductibleOptions(
                jobNumber,
                lobCode,
                fixedId,
                coverageId,
                sessionId,
                !isLoggedOn
            );
        }
});
